/* Vitrine do time na PDP (ver sections/md-vitrine-time.liquid).
 *
 * Duas tarefas:
 * 1) Titulo: aparece quando o md-team-names.js escreve o nome do time no
 *    <span data-md-team-label>. Sem nome (codigo fora do dicionario ou servico
 *    fora do ar por 5 s), entra o titulo reserva da section, sem o escudo.
 * 2) Pilulas: um tipo por vez, sem "All". Tocar numa pilula busca a colecao do
 *    time ja filtrada pela Shopify (section md-vitrine-time-itens), tira o
 *    produto da propria pagina e troca os cartoes do carrossel. Tocar na ativa
 *    volta pra lista inicial. So entra produto com estoque. Resposta guardada por tipo: o segundo toque no
 *    mesmo tipo nao vai a rede. Falha de rede: o link segue e abre a colecao
 *    filtrada.
 *
 * O meio botao cortado das pilulas no celular e do md-atalhos-tipo.js, que
 * cuida de toda faixa da pagina; o clique destas ele ignora (data-md-tipos-local).
 */
(function () {
  "use strict";

  var SECAO_ITENS = "md-vitrine-time-itens";
  var ESPERA_NOME = 5000;

  function nomear(raiz) {
    var titulo = raiz.querySelector("[data-md-vt-titulo]");
    var alvo = titulo && titulo.querySelector("[data-md-team-label]");

    function mostrar() {
      raiz.classList.add("md-vt--nomeado");
    }

    function reserva() {
      var texto = titulo && titulo.querySelector(".md-vt__texto");
      var escudo = titulo && titulo.querySelector(".md-vt__escudo");
      if (texto) texto.textContent = raiz.getAttribute("data-md-vt-reserva") || "";
      if (escudo) escudo.remove();
      mostrar();
    }

    if (!alvo) {
      mostrar();
      return;
    }

    function resolver() {
      var estado = alvo.getAttribute("data-md-named");
      if (estado === "1") {
        mostrar();
        return true;
      }
      if (estado === "sem-rotulo") {
        reserva();
        return true;
      }
      return false;
    }

    if (resolver()) return;
    var obs = window.MutationObserver
      ? new MutationObserver(function () {
          if (resolver()) obs.disconnect();
        })
      : null;
    if (obs) obs.observe(alvo, { attributes: true, attributeFilter: ["data-md-named"] });
    setTimeout(function () {
      if (resolver()) return;
      if (obs) obs.disconnect();
      reserva();
    }, ESPERA_NOME);
  }

  function marcar(raiz, pilula) {
    var todas = raiz.querySelectorAll(".md-tipos__pilula");
    for (var i = 0; i < todas.length; i++) {
      var ativa = todas[i] === pilula;
      todas[i].classList.toggle("md-tipos__pilula--ativa", ativa);
      if (ativa) todas[i].setAttribute("aria-current", "true");
      else todas[i].removeAttribute("aria-current");
    }
  }

  function iniciar(raiz) {
    if (raiz.getAttribute("data-md-vt-pronto")) return;
    raiz.setAttribute("data-md-vt-pronto", "1");

    var trilho = raiz.querySelector("[data-md-trilho]");
    var url = raiz.getAttribute("data-md-vt-url");
    var atual = raiz.getAttribute("data-md-vt-produto");
    var limite = parseInt(raiz.getAttribute("data-md-vt-limite"), 10) || 12;
    var inicial = trilho ? trilho.innerHTML : "";
    var guardadas = {};
    var vez = 0;

    nomear(raiz);
    if (!trilho || !url) return;

    function trocar(html) {
      raiz.classList.remove("md-vt--carregando");
      trilho.innerHTML = html;
      trilho.scrollLeft = 0;
      /* o carrossel comum redesenha barra e setas no evento de scroll */
      trilho.dispatchEvent(new Event("scroll"));
    }

    raiz.addEventListener("click", function (e) {
      var pilula = e.target.closest ? e.target.closest("[data-md-tipo-param]") : null;
      if (!pilula || !raiz.contains(pilula)) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (typeof fetch !== "function" || typeof DOMParser === "undefined") return;
      e.preventDefault();

      var minha = ++vez;
      if (pilula.classList.contains("md-tipos__pilula--ativa")) {
        marcar(raiz, null);
        trocar(inicial);
        return;
      }
      marcar(raiz, pilula);

      var param = pilula.getAttribute("data-md-tipo-param");
      var valor = pilula.getAttribute("data-md-tipo-valor");
      var chave = param + "=" + valor;
      if (guardadas[chave] !== undefined) {
        trocar(guardadas[chave]);
        return;
      }

      raiz.classList.add("md-vt--carregando");
      var busca = new URLSearchParams();
      busca.set("section_id", SECAO_ITENS);
      busca.append(param, valor);
      busca.set("filter.v.availability", "1");
      fetch(url + "?" + busca.toString(), { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error(String(r.status));
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var itens = doc.querySelectorAll("li[data-md-vt-id]");
          var partes = [];
          for (var i = 0; i < itens.length && partes.length < limite; i++) {
            if (itens[i].getAttribute("data-md-vt-id") === atual) continue;
            partes.push(itens[i].outerHTML);
          }
          guardadas[chave] = partes.join("");
          if (minha !== vez) return;
          if (!partes.length) {
            /* nao deveria acontecer (a pilula so existe com produto do tipo) */
            marcar(raiz, null);
            trocar(inicial);
            return;
          }
          trocar(guardadas[chave]);
        })
        .catch(function () {
          if (minha !== vez) return;
          raiz.classList.remove("md-vt--carregando");
          window.location.href = pilula.href;
        });
    });
  }

  function varrer(raiz) {
    var alvos = (raiz || document).querySelectorAll("[data-md-vt]");
    for (var i = 0; i < alvos.length; i++) iniciar(alvos[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      varrer();
    });
  } else {
    varrer();
  }

  /* secao re-renderizada pelo editor de tema */
  document.addEventListener("shopify:section:load", function (e) {
    varrer(e.target);
  });
})();
